import './styles.scss';
import cn from "classnames";
import {FC, ReactNode} from "react";

interface ButtonProps {
  onClick: () => void;
  onTouchEnd?: () => void;
  disabled?: boolean;
  variant?: 'primary' | 'secondary' | 'tertiary';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  children?: ReactNode;
}
const Button:FC<ButtonProps> = ({
  onClick,
  onTouchEnd,
  disabled,
  variant,
  size,
  className,
  children
})  => {

  const buttonClassNames = cn({
    button: true,
    [`button--${variant}`]: variant,
    [`button--${size}`]: size,
    [`${className}`]: className
  });

  return (
    <button
      disabled={!!disabled}
      onClick={onClick}
      onTouchEnd={onTouchEnd}
      className={buttonClassNames}
    >
      {children}
    </button>
  )
}

export default Button;